var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMultivendorV2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 18.781L12 18.5l-7.184-1.347A1 1 0 014 16.17V14a1 1 0 011-1h14a1 1 0 011 1v4.795a1 1 0 01-1.184.983L18 19.625l-.5-.125",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.518 19.967a2 2 0 103.863-1.035 2 2 0 00-3.863 1.035z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7 21v-3M9 12h3M17 8v5M7 8v5",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20 4v3.382a1 1 0 01-1.447.894l-1.062-.53a1 1 0 00-.962.036l-1.514.91a1 1 0 01-1.03 0l-1.47-.883a1 1 0 00-1.03 0l-1.47.882a1 1 0 01-1.03 0l-1.514-.909a1 1 0 00-.962-.037l-1.062.531A1 1 0 014 7.382V4h16z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })));
}
export default SvgMultivendorV2;